//@ts-ignore
import { CLESSON_MODES } from '../../../constants';

export type AssignmentTable = Record<number, Array<string>>;

export enum PREDEFINED_DATES {
    NOW = 'now',
    ON_FRIDAY = 'on_friday',
    IN_FIFTEEN_MINUTES = 'in_fifteen_minutes',
    NEXT_DAY = 'next_day',
    ON_MONDAY = 'on_monday',
}

export enum EVAUATION_DATES {
    EQUAL_DEADLIINE = 'equal_deadline',
}

interface WithDate<T> {
    date: T;
}
interface WithPredefined {
    predefined: PREDEFINED_DATES | EVAUATION_DATES;
    timezone?: number;
}

export type DateOption<T = Date> = WithDate<T> | WithPredefined;

export interface LessonInfo {
    assignmentDate: DateOption;
    finishDeadline: DateOption<Date | null>;
}

export interface ControlInfo {
    assignmentDate: DateOption;
    evaluationDate: DateOption;
    startDeadline: DateOption;
    duration: number | null;
}

interface LessonAssignmentInfo extends LessonInfo {
    lessonMode: CLESSON_MODES;
}

interface ControlAssignmentInfo extends ControlInfo {
    lessonMode: CLESSON_MODES;
}

export type AssignmentInfo = LessonAssignmentInfo | ControlAssignmentInfo;

